import React from 'react';

interface TicketSelectionCheckboxProps {
  ticketId: string;
  isSelected: boolean;
  onToggle: (ticketId: string) => void;
  disabled?: boolean;
}

export const TicketSelectionCheckbox: React.FC<TicketSelectionCheckboxProps> = ({
  ticketId,
  isSelected,
  onToggle,
  disabled = false
}) => {
  return (
    <div className="flex items-center">
      <input
        type="checkbox"
        checked={isSelected}
        onChange={() => onToggle(ticketId)}
        disabled={disabled}
        className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded cursor-pointer"
      />
    </div>
  );
};
